import english from './i18n/en.json' with {type: 'json'};
export const LANGUAGES = ['de', 'en', 'fr', 'es', 'it', 'nl', 'pl', 'pt', 'sv', 'cs'];
const LOCALES = {de:'de-DE', en:'en-GB', fr:'fr-FR', es:'es-ES', it:'it-IT', nl:'nl-NL', pl:'pl-PL', pt:'pt-PT', sv:'sv-SE', cs:'cs-CZ'};
let language = 'en', catalog = english, request = 0;
export function chooseLanguage(preference = 'auto', languages = globalThis.navigator?.languages || []) {
  if (LANGUAGES.includes(preference)) return preference;
  return languages.map(tag => tag.toLowerCase().split('-')[0]).find(tag => LANGUAGES.includes(tag)) || 'en';
}
export function setCatalog(lang, values) { language = LANGUAGES.includes(lang) ? lang : 'en'; catalog = {...english, ...values}; }
// English is part of the entry; the others are lazy imports, which the release build turns into one content-hashed chunk each.
const CATALOGS = {
  de: () => import('./i18n/de.json', {with: {type: 'json'}}), fr: () => import('./i18n/fr.json', {with: {type: 'json'}}), es: () => import('./i18n/es.json', {with: {type: 'json'}}),
  it: () => import('./i18n/it.json', {with: {type: 'json'}}), nl: () => import('./i18n/nl.json', {with: {type: 'json'}}), pl: () => import('./i18n/pl.json', {with: {type: 'json'}}),
  pt: () => import('./i18n/pt.json', {with: {type: 'json'}}), sv: () => import('./i18n/sv.json', {with: {type: 'json'}}), cs: () => import('./i18n/cs.json', {with: {type: 'json'}}),
};
export async function loadLanguage(preference, languages, loader = async lang => (await CATALOGS[lang]()).default) {
  const lang = chooseLanguage(preference, languages), current = ++request;
  try {
    const values = lang === 'en' ? english : await loader(lang);
    if(current!==request)return language;
    setCatalog(lang,values);
  } catch { if(current!==request)return language;setCatalog('en', english); }
  if (globalThis.document?.documentElement) document.documentElement.lang = language;
  return language;
}
export const locale = () => LOCALES[language];
export const number = (value, options = {}) => new Intl.NumberFormat(locale(), options).format(value);
export const currency = value => number(value, {style:'currency', currency:'EUR'});
export const day = value => new Intl.DateTimeFormat(locale(), {dateStyle:'medium', timeZone:'UTC'}).format(new Date(value));
// An instant in the station's zone (IANA name from the site); without one, the browser's zone.
export const date = (value, timeZone) => new Intl.DateTimeFormat(locale(), {dateStyle:'medium', timeStyle:'short', ...(timeZone ? {timeZone} : {})}).format(new Date(value));
export function t(key, values = {}) { return (catalog[key] ?? english[key] ?? key).replace(/\{(\w+)\}/g, (_, name) => values[name] ?? `{${name}}`); }
// Connector names stay canonical in data, URLs and MCP; only Type 1/2/3C get a localized label.
const PLUG_KEYS = {'Type 1':'plugType1', 'Type 2':'plugType2', 'Type 3C':'plugType3C'};
export const plugName = name => PLUG_KEYS[name] ? t(PLUG_KEYS[name]) : name;
export function plural(key, n) {
  const form = new Intl.PluralRules(locale()).select(n);
  const selected = key + form[0].toUpperCase() + form.slice(1);
  return t(catalog[selected] ? selected : key + 'Other', {n:number(n)});
}
